import React from "react";

export default function Menu({ broker }) {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">USERNAME</div>
      <div className="menuExchange">SHARING</div>
      {broker.nse === 1 ? <div className="menuExchange">C-NSE</div> : null}
      {broker.nsecash === 1 ? (
        <div className="menuExchange">C-NSE-EQUITY</div>
      ) : null}
      {broker.mcx === 1 ? <div className="menuExchange">C-MCX</div> : null}
      {broker.mcx_options === 1 ? (
        <div className="menuExchange">C-MCX-OPTIONS</div>
      ) : null}
      {broker.options === 1 ? (
        <div className="menuExchange">C-NSE-OPTIONS</div>
      ) : null}

      {broker.comex === 1 ? <div className="menuExchange">C-COMEX</div> : null}
      {broker.crypto === 1 ? (
        <div className="menuExchange">C-CRYPTO</div>
      ) : null}
      {broker.forex === 1 ? <div className="menuExchange">C-FOREX</div> : null}
      {broker.sgx === 1 ? <div className="menuExchange">C-SGX</div> : null}
      {broker.us_stock === 1 ? (
        <div className="menuExchange">C-US-STOCK</div>
      ) : null}
      {broker.index === 1 ? <div className="menuExchange">C-OTHERS</div> : null}
      {broker.dgcx === 1 ? <div className="menuExchange">C-DGCX</div> : null}
      {broker.ncdex === 1 ? <div className="menuExchange">C-NCDEX</div> : null}

      {broker.nse === 1 ? <div className="menuExchange">B-NSE</div> : null}
      {broker.nsecash === 1 ? (
        <div className="menuExchange">B-NSE-EQUITY</div>
      ) : null}
      {broker.mcx === 1 ? <div className="menuExchange">B-MCX</div> : null}
      {broker.mcx_options === 1 ? (
        <div className="menuExchange">B-MCX-OPTIONS</div>
      ) : null}
      {broker.options === 1 ? (
        <div className="menuExchange">B-NSE-OPTIONS</div>
      ) : null}

      {broker.comex === 1 ? <div className="menuExchange">B-COMEX</div> : null}
      {broker.crypto === 1 ? (
        <div className="menuExchange">B-CRYPTO</div>
      ) : null}
      {broker.forex === 1 ? <div className="menuExchange">B-FOREX</div> : null}
      {broker.sgx === 1 ? <div className="menuExchange">B-SGX</div> : null}
      {broker.us_stock === 1 ? (
        <div className="menuExchange">B-US-STOCK</div>
      ) : null}
      {broker.index === 1 ? <div className="menuExchange">B-OTHERS</div> : null}
      {broker.dgcx === 1 ? <div className="menuExchange">B-DGCX</div> : null}
      {broker.ncdex === 1 ? <div className="menuExchange">B-NCDEX</div> : null}
    </div>
  );
}
